<template>
    <!-- Componente sombreado que contiene todos las funciones de un mismo tipo -->
    <v-card shaped class="mb-5">
        <v-card-title class="titulo_card">{{ title }}</v-card-title>
        <v-card-text>
            <v-row>
                <!-- Iteramos cada una de las funciones -->
              <template v-for="(item) in items">
                <v-col v-if="item.visible" cols="6" sm="4" md="2" class="text-center">
                  <MenuElement
                      :icon="item.icon" :text="item.text"
                      :dialog_component="item.dialog_component"
                      :dialog_title="item.dialog_title"
                      :route="item.route"
                      :method="item.method"
                      :disabled="item.disabled"
                      :nuevo="item.nuevo"
                  />
                </v-col>
              </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'MenuCard',
    // Propiedad recibida desde el componente padre
    props: ['title', 'items'],
    data: () => ({
        dialog: false,
    }),
    // Componentes del proyecto
    components: {
        MenuElement: () => import('@/components/shared/MenuElement'),
    }
}

</script>
